export default "__VITE_ASSET__DAGfTQd8__"